module.exports = __webpack_public_path__ + "img/persona.8e64def6.png";